module.exports = __webpack_public_path__ + "static/img/home-txt.013012a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-txt.png
// module id = VOmE
// module chunks = 1